"use client";

import type { DynamicDocumentInstructions } from "@/configuration/document-mappings/types";
import CoverageCard from "@/src/components/cards/coverage-card/coverage-card";
import PatientCard from "@/src/components/cards/patient-card/patient-card";
import ReferralCard from "@/src/components/cards/referral-card/referral-card";
import { DocumentInstructionsCardView } from "@/src/components/tasks/document-management-instructions";
import { ReferralProviderCards } from "@/src/components/tasks/referral-provider-cards";
import { useBuildInstructions } from "@/src/components/tasks/use-processed-instructions";
import type { StepOutputs } from "@/src/lib/workflows/steps/step-outputs";
import type { Referral } from "@/src/models/documents/referral";
import type { Section } from "@/src/models/section";
import type { Task } from "@/src/models/task";

export function AcsReferralInstructions({
  referral,
  task,
  section,
  instructions,
  stepOutputs,
}: {
  referral: Referral;
  task: Task;
  section: Section;
  instructions: DynamicDocumentInstructions | null;
  stepOutputs: StepOutputs;
}) {
  const data = useBuildInstructions(task, section, instructions, stepOutputs, null);

  return (
    <div className="space-y-8 text-foreground">
      {data && <DocumentInstructionsCardView data={data} />}
      <PatientCard patient={referral.patient} />
      <ReferralProviderCards referral={referral} />
      <ReferralCard referral={referral} isEditable />
      {referral.primaryCoverage && <CoverageCard coverage={referral.primaryCoverage} type="Primary" isEditable />}
      {referral.secondaryCoverage && <CoverageCard coverage={referral.secondaryCoverage} type="Secondary" isEditable />}
    </div>
  );
}
